import { formSteps } from "@/data/create-exam";
import { clsx, type ClassValue } from "clsx";
import { toast } from "sonner";
import { twMerge } from "tailwind-merge";
import { TCreateExamFormSchemaFields } from "./form-schemas/schema";
import { UseFormGetValues } from "react-hook-form";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

export const computeExamCreationStages = (step: number): ICreateExamStages => {
	const currentIndex = formSteps.findIndex((item) => item.step === step);

	return {
		current: {
			target: formSteps[currentIndex].step,
			label: formSteps[currentIndex].title,
		},
		prev: formSteps[currentIndex - 1]
			? {
					target: formSteps[currentIndex - 1].step,
					label: formSteps[currentIndex - 1].title,
			  }
			: { target: null, label: "" },
		next: formSteps[currentIndex + 1]
			? {
					target: formSteps[currentIndex + 1].step,
					label: formSteps[currentIndex + 1].title,
			  }
			: { target: null, label: "" },
	};
};

export const generateBreadcrumbs = (pathname: string) => {
	// Split pathname and filter out empty strings
	const segments = pathname.split("/").filter(Boolean);

	// Skip the first segment (usually "dashboard" or app root)
	const breadcrumbSegments = segments.slice(1);

	return breadcrumbSegments.map((segment, index) => {
		// Format the segment (replace hyphens/underscores with spaces)
		const label = segment.replace(/-/g, " ").replace(/_/g, " ");

		// Build the href by joining segments up to current index
		const href = "/" + segments.slice(0, index + 2).join("/");

		// Check if this is the last segment
		const isLast = index === breadcrumbSegments.length - 1;

		return {
			label,
			href,
			isLast,
		};
	});
};

export const handleSave = (
	currentDraftId: string,
	getValues: UseFormGetValues<TCreateExamFormSchemaFields>,
	saveFormData: (id: string, data: TCreateExamFormSchemaFields) => void,
	saveSections: (id: string, sections: Section[]) => void,
	addedSections: Section[]
) => {
	const { title, ...rest } = getValues();

	if (!title || title.trim().length === 0) {
		toast.error("Please provide a title before saving");
		return;
	}

	saveFormData(currentDraftId, { title, ...rest });
	saveSections(currentDraftId, addedSections);
	toast.success("Saved Changes");
};
